import i18n from 'i18next'

export * from './initializeI18n'
export * from './requireResourceFiles'

export default i18n
